import React from "react";
import ReactDOM from 'react-dom'
import './MoveWith.scss'
import {BrandAdverbs} from './BrandAdverbs';
//@ts-ignore
import Slider from "react-slick";
import { Header } from '../../../header';
import { useSpring, a, config } from 'react-spring'
import { Button } from "components/button";
import Animation from './Animation';
//import {BrandAdverbs} from './BrandAdverbs';
import { navigate } from '@reach/router';
import { Home } from 'screens/home'
// import { IntroVideo } from "components/IntroVideo";
import { IntroVideoScreen } from "../../../../screens/introVideoScreen";
export interface MoveWithCardProps {
  height?: any;
}

export interface MoveWithCardState {
  isAnimated?: boolean;
}

class MoveWithCard extends React.Component<MoveWithCardProps, MoveWithCardState> {
    slider: any;
    constructor(props: MoveWithCardProps) {
        super(props);
        this.state = {
          isAnimated: true
        };
    }

    componentDidMount() {
      let element: any = document.querySelector('main');
      let cardopen: any = element.classList.contains('frozen');
      let metaTag: any  = document.querySelector('meta[name="theme-color"]');

      if (cardopen === false) {
        let themeColor: any = metaTag.content ="#F3EFE4";
        console.log("the theme color is tan");
      }

    }

    onLeftIconPress() {
        navigate('/move');
    }

    stopAnimation() {
      this.setState({isAnimated: false});
    }



    render() {

        return (
          <IntroVideoScreen />
         );
    }
}

export default MoveWithCard;
